export default "__VITE_ASSET__jxpOqoL0__"